import axios from '@/plugins/axios/index';

const AUTH_BASE_URL = `${process.env.VUE_APP_API_URL}`;

export async function getListUserInvite(pagination): Promise<any> {
    var pagiStr = '?per_page=' + pagination.per_page + '&page=' + pagination.page + '&search=' + pagination.search;
    const response = await axios.get(`${AUTH_BASE_URL}/user-invite`+pagiStr);
    return response;
}

export async function getListHistoriesCollaborators(pagination): Promise<any> {
    var pagiStr = '?per_page=' + pagination.per_page + '&page=' + pagination.page;
    return await axios.get(`${AUTH_BASE_URL}/histories/collaborator`+pagiStr);
}
export async function getCollaborators(): Promise<any> {
    return await axios.get(`${AUTH_BASE_URL}/collaborators`);
}
export async function createCollaborators(): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/collaborators`);
}
export async function estimatedWithdraws(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/collaborators/estimated-withdraw`, params);
}
export async function withdraws(params): Promise<any> {
    return await axios.post(`${AUTH_BASE_URL}/collaborators/withdraw`, params);
}
